import { Component, OnInit } from "@angular/core";
import {
  AlertController,
  ModalController,
  NavController,
  NavParams,
  Platform,
} from "@ionic/angular";
import { Geolocation } from "@capacitor/geolocation";
import { NavigationExtras } from "@angular/router";
import { GeoLocationService } from "src/app/services/geo-service.service";
import { NetworkService } from "src/app/services/network.service";
import { slideInTransition } from "src/app/animations/page-transitions";

@Component({
  selector: "app-modal-pdv",
  templateUrl: "./modal-pdv.component.html",
  styleUrls: ["./modal-pdv.component.scss"],
  standalone: false,
})
export class ModalPdvComponent implements OnInit {
  pdv: any;
  address: string;
  latitude: number;
  longitude: number;
  cordova = false;
  telformat = "";
  typeListe: any;

  constructor(
    private navCtrl: NavController,
    private modalController: ModalController,
    private navParams: NavParams,
    public platform: Platform,
    private geolocation: GeoLocationService,
    private alertController: AlertController,
    private networkService: NetworkService
  ) {}

  ngOnInit() {
    if (this.platform.is("cordova")) {
      this.cordova = true;
    }
    this.pdv = this.navParams.get("pdv");
    this.typeListe = this.navParams.get("typeListe");
    this.address = `${this.pdv.address1_line1} ${this.pdv.address1_postalcode} ${this.pdv.address1_city}`;
    if (this.pdv.telephone1) {
      this.telformat = this.pdv.telephone1.replace(/\s/g, "");
    }
    Geolocation.getCurrentPosition().then((coordinates) => {
      this.latitude = coordinates.coords.latitude;
      this.longitude = coordinates.coords.longitude;
    });
  }

  close() {
    this.modalController.dismiss();
  }

  openMap(latitude: number, longitude: number, address: string) {
    const link = `https://www.google.com/maps/dir/?api=1&origin=${latitude},${longitude}&destination=${address}`;
    this.geolocation.openMap(link, this.pdv.latitude, this.pdv.longitude);
  }

  openSurvey() {
    if (!this.networkService.isOnline) {
      this.alertController
        .create({
          message:
            "Activer votre connexion pour pouvoir charger et actualiser le formulaire de ce survey",
          buttons: ["OK"],
        })
        .then((toast) => toast.present());
      return;
    }
    const navigationExtras: NavigationExtras = {
      state: {
        pdv: this.pdv,
        typeListe: this.typeListe,
      },
    };
    this.modalController.dismiss().then(() => {
      this.navCtrl.navigateForward(["/survey"], {
        ...navigationExtras,
        animation: slideInTransition,
      });
    });
  }

  openMail() {
    const a = document.createElement("a");
    a.href = "mailto:" + this.pdv.email;
    a.click();
  }

  openCall() {
    let a = document.createElement("a");
    a.href = "tel:" + this.telformat;
    a.click();
  }

  openInfosPdv() {
    const navigationExtras: NavigationExtras = {
      state: {
        pdv: this.pdv,
      },
    };
    this.modalController.dismiss().then(() => {
      this.navCtrl.navigateForward(["/infos-pdv"], {
        ...navigationExtras,
        animation: slideInTransition,
      });
    });
  }
}
